// Client-side i18n backed by Rails-injected translations (see layouts/application.html.erb).

function getStore() {
  if (typeof window !== "undefined" && window.__TAAGGER_I18N__) {
    return window.__TAAGGER_I18N__
  }
  return {}
}

function lookup(key, store) {
  let parts = key.split(".")
  if (parts[0] === "javascript") parts = parts.slice(1)
  let cur = store
  for (const part of parts) {
    if (cur == null || typeof cur !== "object") return undefined
    cur = cur[part]
  }
  if (typeof cur === "string") return cur
  if (cur && typeof cur === "object") return cur
  return undefined
}

// Minimal Rails-style pluralization: when a key resolves to a hash of plural
// forms ({ one:, other:, ... }) and a numeric `count` option is given, pick the
// form via Intl.PluralRules for the page locale (falling back to "other").
function selectPlural(entry, count) {
  if (!entry || typeof entry !== "object") return undefined
  if (count === 0 && typeof entry.zero === "string") return entry.zero
  let category = "other"
  try {
    category = new Intl.PluralRules(currentLocale()).select(Number(count))
  } catch (_e) {
    category = Number(count) === 1 ? "one" : "other"
  }
  if (typeof entry[category] === "string") return entry[category]
  return typeof entry.other === "string" ? entry.other : undefined
}

export function t(key, options = {}) {
  const store = getStore()
  let entry = lookup(key, store)
  if (entry && typeof entry === "object") {
    entry = options.count !== undefined ? selectPlural(entry, options.count) : undefined
  }
  let template = entry ?? key

  Object.entries(options).forEach(([name, value]) => {
    // Function replacers so "$" sequences in values are inserted literally.
    template = template.replace(new RegExp(`%\\{${name}\\}`, "g"), () => String(value))
    template = template.replace(new RegExp(`\\{\\{${name}\\}\\}`, "g"), () => String(value))
  })
  return template
}

export function currentLocale() {
  if (typeof document !== "undefined") {
    return document.documentElement.lang || "en"
  }
  return "en"
}
